import React, { useState, useEffect, useContext } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
// eslint-disable-next-line no-unused-vars
import { userData, filterRole, filterStatus } from "./UserData";
import moment from "moment";

import {
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
  TooltipComponent,
} from "../../../components/Component";
// eslint-disable-next-line no-unused-vars
import { useForm } from "react-hook-form";
import { UserContext } from "./UserContext";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/Utils";
import ConfirmModal from "../../../components/partials/user-manage/ConfirmModal";
import swal from "sweetalert";

const Employees = () => {
  const { contextData } = useContext(UserContext);
  const [data, setData] = contextData;

  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [modal, setModal] = useState({
    edit: false,
    add: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    _id: "",
    employee_name: "",
    employee_email: "",
    employee_phone: "",
    employee_country_code: "",
    organization_name: "",
    organization_contact_person_name: "",
    organization_contact_person_email: "",
    organization_contact_person_phone: "",
    organization_contact_person_country_code: "",
    country: "",
    remarks: "",
    status: "",
    createdAt: "",
  });
  const [actionText, setActionText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [itemPerPage, setItemPerPage] = useState(10);
  // eslint-disable-next-line no-unused-vars
  const [sort, setSortState] = useState(""); // sort, setSortState are only written, never read
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [submittedData, setSubmitData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [errorVal, setError] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState({
    isOpen: false,
    type: null,
    employee: null,
    onConfirm: null,
  });
  // eslint-disable-next-line no-unused-vars
  const [token] = useState(localStorage.getItem("accessToken"));

  // Sorting data - sortFunc is defined but never used
  // eslint-disable-next-line no-unused-vars
  const sortFunc = (params) => {
    let defaultData = data;
    if (params === "asc") {
      let sortedData = defaultData.sort((a, b) => a.name.localeCompare(b.name));
      setEmployeeList([...sortedData]);
    } else if (params === "dsc") {
      let sortedData = defaultData.sort((a, b) => b.name.localeCompare(a.name));
      setEmployeeList([...sortedData]);
    }
  };

  // unselects the data on mount
  useEffect(() => {
    let newData;
    newData = userData.map((item) => {
      item.checked = false;
      return item;
    });
    setEmployeeList([...newData]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch employee list (used on mount and after delete)
  const fetchEmployeeList = () => {
    const t = localStorage.getItem("accessToken");
    axios
      .get(`${API_BASE_URL}/api/v1/contact-employee`, {
        headers: { Authorization: `Bearer ${t}` },
      })
      .then((response) => {
        setEmployeeList(response.data.data || []);
        setData(response.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  useEffect(() => {
    fetchEmployeeList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      console.log(data);
      const filteredObject = employeeList.filter((item) => {
        return (
          item.employee_name.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.organization_contact_person_phone.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.organization_contact_person_name.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.organization_name.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.employee_phone.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.country.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.status.toLowerCase().includes(onSearchText.toLowerCase())
        );
      });
      setEmployeeList([...filteredObject]);
    } else {
      setEmployeeList([...data]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSearchText]);

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // eslint-disable-next-line no-unused-vars
  const _onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].checked = e.currentTarget.checked;
    setData([...newData]);
  };

  // eslint-disable-next-line no-unused-vars
  const _onActionText = (e) => {
    setActionText(e.value);
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({
      _id: "",
      employee_name: "",
      employee_email: "",
      employee_phone: "",
      employee_country_code: "",
      organization_name: "",
      organization_contact_person_name: "",
      organization_contact_person_email: "",
      organization_contact_person_phone: "",
      organization_contact_person_country_code: "",
      country: "",
      remarks: "",
      status: "",
      createdAt: "",
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const confirmDeleteEmployee = (item) => {
    const id = item._id || item.id;
    if (!id) return;
    setShowConfirmModal({
      isOpen: true,
      type: "deleteEmployee",
      employee: item,
      onConfirm: () => {
        performDeleteEmployee(id);
        setShowConfirmModal({ isOpen: false, type: null, employee: null, onConfirm: null });
      },
    });
  };

  const performDeleteEmployee = (id) => {
    setLoading(true);
    const t = localStorage.getItem("accessToken");
    axios
      .delete(`${API_BASE_URL}/api/v1/contact-employee/${id}`, {
        headers: { Authorization: `Bearer ${t}` },
      })
      .then(() => {
        swal("Success", "Employee deleted successfully", "success");
        fetchEmployeeList();
      })
      .catch((error) => {
        console.error("Error deleting employee:", error);
        swal("Error", error.response?.data?.message || "Failed to delete employee", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // submit function to add a new item
  const onFormSubmit = (submitData) => {
    setLoading(true);
    const submittedData = {
      _id: submitData._id,
      employee_name: submitData.employee_name,
      employee_email: submitData.employee_email,
      employee_phone: submitData.employee_phone,
      employee_country_code: submitData.employee_country_code,
      organization_name: submitData.organization_name,
      organization_contact_person_name: submitData.organization_contact_person_name,
      organization_contact_person_email: submitData.organization_contact_person_email,
      organization_contact_person_phone: submitData.organization_contact_person_phone,
      organization_contact_person_country_code: submitData.organization_contact_person_country_code,
      country: submitData.country,
      remarks: submitData.remarks,
      status: formData.status,
      createdAt: submitData.createdAt,
    };
    axios
      .post("http://192.168.29.175:3000/api/v1/admin/create-user", submittedData, {
        headers: {
          Authorization: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setSubmitData(response.submitData);
        setFormData("");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error.message);
        setTimeout(() => {
          setError(error.message);
          setLoading(false);
        }, 2000);
      });

    setData([submittedData, ...data]);
    resetForm();
    setModal({ edit: false }, { add: false });
    window.location.reload(false);
  };

  // submit function to update a new item
  const onEditSubmit = (submitData) => {
    setLoading(true);
    // const { name, email, phone } = submitData;
    let submittedData;
    let newitems = employeeList;
    newitems.forEach((item) => {
      if (item._id === editId) {
        submittedData = {
          employee_name: submitData.employee_name,
          employee_email: submitData.employee_email,
          employee_phone: submitData.employee_phone,
          employee_country_code: submitData.employee_country_code,
          organization_name: submitData.organization_name,
          organization_contact_person_name: submitData.organization_contact_person_name,
          organization_contact_person_email: submitData.organization_contact_person_email,
          organization_contact_person_phone: submitData.organization_contact_person_phone,
          organization_contact_person_country_code: submitData.organization_contact_person_country_code,
          country: submitData.country,
          remarks: submitData.remarks,
          status: formData.status,
          createdAt: submitData.createdAt,
        };
      }
    });
    console.log(submittedData);
    axios
      .put(`${API_BASE_URL}/api/v1/quote/${editId}`, submittedData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response);
        let index = newitems.findIndex((item) => item._id === editId);
        console.log(index);
        submittedData.email = index.email;
        newitems[index] = response.data.data;
        setModal({ edit: false });
        // window.location.reload(false);
      })
      .catch(function (error) {
        console.log(error.message);
        setTimeout(() => {
          setError(error.message);
          setLoading(false);
        }, 2000);
      });
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    employeeList.forEach((item) => {
      if (item._id === id) {
        setFormData({
          _id: item._id,
          employee_name: item.employee_name,
          employee_email: item.employee_email,
          employee_phone: item.employee_phone,
          employee_country_code: item.employee_country_code,
          organization_name: item.organization_name,
          organization_contact_person_name: item.organization_contact_person_name,
          organization_contact_person_email: item.organization_contact_person_email,
          organization_contact_person_phone: item.organization_contact_person_phone,
          organization_contact_person_country_code: item.organization_contact_person_country_code,
          country: item.country,
          remarks: item.remarks,
          status: item.status,
          createdAt: item.createdAt,
        });
        setModal({ edit: true }, { add: false });
        setEditedId(item._id);
      }
    });
  };

  const confirmSuspendEmployee = (item) => {
    setShowConfirmModal({
      isOpen: true,
      type: "suspendEmployee",
      employee: item,
      onConfirm: () => {
        suspendUser(item.id);
        setShowConfirmModal({ isOpen: false, type: null, employee: null, onConfirm: null });
      },
    });
  };

  const suspendUser = (id) => {
    const newData = [...data];
    const index = newData.findIndex((item) => item.id === id);
    if (index !== -1) {
      newData[index].status = "Suspend";
      setData(newData);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const _onActionClick = (e) => {
    if (actionText === "suspend") {
      let newData = data.map((item) => {
        if (item.checked === true) item.status = "Suspend";
        return item;
      });
      setData([...newData]);
    } else if (actionText === "delete") {
      let newData;
      newData = data.filter((item) => item.checked !== true);
      setData([...newData]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.checked = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  const { errors, register, handleSubmit } = useForm();

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="User List - Compact"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Employee Lists
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {employeeList.length} users.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                {/* <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <a
                        href="#export"
                        onClick={(ev) => {
                          ev.preventDefault();
                        }}
                        className="btn btn-white btn-outline-light"
                      >
                        <Icon name="download-cloud"></Icon>
                        <span>Export</span>
                      </a>
                    </li>
                    <li className="nk-block-tools-opt">
                      <Button color="primary" className="btn-icon" onClick={() => setModal({ add: true })}>
                        <Icon name="plus"></Icon>
                      </Button>
                    </li>
                  </ul>
                </div> */}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch" scrollable>
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    <li>
                      <div className="toggle-wrap">
                        <Button
                          className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                          onClick={() => updateTableSm(true)}
                        >
                          <Icon name="menu-right"></Icon>
                        </Button>
                        <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                          <ul className="btn-toolbar gx-1">
                            <li className="toggle-close">
                              <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                <Icon name="arrow-left"></Icon>
                              </Button>
                            </li>
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <div className="dot dot-primary"></div>
                                  <Icon name="filter-alt"></Icon>
                                </DropdownToggle>
                                <DropdownMenu
                                  right
                                  className="filter-wg dropdown-menu-xl"
                                  style={{ overflow: "visible" }}
                                >
                                  <div className="dropdown-head">
                                    <span className="sub-title dropdown-title">Filter Users</span>
                                    <div className="dropdown">
                                      <DropdownItem
                                        href="#more"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                        className="btn btn-sm btn-icon"
                                      >
                                        <Icon name="more-h"></Icon>
                                      </DropdownItem>
                                    </div>
                                  </div>
                                  <div className="dropdown-body dropdown-body-rg">
                                    <Row className="gx-6 gy-3">
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasBalance"
                                          />
                                          <label className="custom-control-label" htmlFor="hasBalance">
                                            {" "}
                                            Have Balance
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasKYC"
                                          />
                                          <label className="custom-control-label" htmlFor="hasKYC">
                                            {" "}
                                            KYC Verified
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Age</label>
                                          <RSelect options={filterRole} placeholder="Any Role" />
                                        </FormGroup>
                                      </Col>
                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Status</label>
                                          <RSelect options={filterStatus} placeholder="Any Status" />
                                        </FormGroup>
                                      </Col>
                                      <Col size="12">
                                        <FormGroup className="form-group">
                                          <Button color="secondary">Filter</Button>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div className="dropdown-foot between">
                                    <a
                                      href="#reset"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                      className="clickable"
                                    >
                                      Reset Filter
                                    </a>
                                    <a
                                      href="#save"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                    >
                                      Save Filter
                                    </a>
                                  </div>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody compact>
              <DataTableHead>
                {/* <DataTableRow className="nk-tb-col-check">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input form-control"
                      onChange={(e) => selectorCheck(e)}
                      id="uid"
                    />
                    <label className="custom-control-label" htmlFor="uid"></label>
                  </div>
                </DataTableRow> */}

                <DataTableRow size="md">
                  <span className="sub-text">Emp. Name</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Emp. Email</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Emp. phone</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Organization Name</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Organization Person Name</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Organization Person Email</span>
                </DataTableRow>
                <DataTableRow size="lg">
                  <span className="sub-text">Organization Person Phone</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Country</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Remark</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Time</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-tools text-right"></DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {currentItems.length > 0
                ? currentItems.map((item) => {
                    return (
                      <DataTableItem key={item.id}>
                        {/* <DataTableRow className="nk-tb-col-check">
                          <div className="custom-control custom-control-sm custom-checkbox notext">
                            <input
                              type="checkbox"
                              className="custom-control-input form-control"
                              defaultChecked={item.checked}
                              id={item.id + "uid1"}
                              key={Math.random()}
                              onChange={(e) => onSelectChange(e, item.id)}
                            />
                            <label className="custom-control-label" htmlFor={item.id + "uid1"}></label>
                          </div>
                        </DataTableRow> */}
                        {/* <DataTableRow>
                          <Link to={`${process.env.PUBLIC_URL}/user-details-regular/${item.id}`}> */}
                        {/* <div className="user-card"> */}
                        {/* <UserAvatar
                                theme={item.avatarBg}
                                className="xs"
                                text={findUpper(item.name)}
                                // image={item.image}

                              ></UserAvatar> */}
                        {/* <div className="user-name">
                                <span className="tb-lead">{item.name} </span>
                              </div>
                            </div> */}
                        {/* </Link>
                        </DataTableRow> */}
                        <DataTableRow size="md" dataLabel="Emp. Name">
                          <span>{item.employee_name}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Emp. Email">
                          <span>{item.employee_email}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Emp. phone">
                          <span>{item.employee_country_code + " " + item.employee_phone}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Organization Name">
                          <span>{item.organization_name}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Organization Person Name">
                          <span>{item.organization_contact_person_name}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Organization Person Email">
                          <span>{item.organization_contact_person_email}</span>
                        </DataTableRow>
                        <DataTableRow size="lg" dataLabel="Organization Person Phone">
                          <span>
                            {item.organization_contact_person_country_code +
                              " " +
                              item.organization_contact_person_phone}
                          </span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Country">
                          <span>{item.country}</span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Remark">
                          <span>{item.remarks}</span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Status">
                          <span>{item.status}</span>
                        </DataTableRow>
                        <DataTableRow size="md" dataLabel="Time">
                          <span>{moment(item.createdAt).format("DD/MM/YY")}</span>
                        </DataTableRow>
                        {/* <DataTableRow size="lg">
                          <ul className="list-status">
                            <li>
                              <Icon
                                className={`text-${
                                  item.emailStatus === "success"
                                    ? "success"
                                    : item.emailStatus === "pending"
                                    ? "info"
                                    : "secondary"
                                }`}
                                name={`${
                                  item.emailStatus === "success"
                                    ? "check-circle"
                                    : item.emailStatus === "alert"
                                    ? "alert-circle"
                                    : "alarm-alt"
                                }`}
                              ></Icon>{" "}
                              <span>Email</span>
                            </li>
                          </ul>
                        </DataTableRow> */}
                        {/* <DataTableRow size="lg">
                          <span>{item.lastLogin}</span>
                        </DataTableRow> */}
                        {/* <DataTableRow>
                          <span
                            className={`tb-status text-${
                              item.status.value === 1 ? "success" : item.status.value === 2 ? "warning" : "danger"
                            }`}
                          >
                            {item.status.value == 1 ? "Active" : item.status.value == 2 ? "Pending" : "Suspended"}
                          </span>
                        </DataTableRow> */}
                        <DataTableRow className="nk-tb-col-tools" dataLabel="Actions">
                          <ul className="nk-tb-actions gx-1">
                            <li className="nk-tb-action-hidden" onClick={() => onEditClick(item._id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"edit" + item.id}
                                icon="edit-alt-fill"
                                direction="top"
                                text="Edit"
                              />
                            </li>
                            {item.status !== "Suspend" && (
                              <React.Fragment>
                                <li className="nk-tb-action-hidden" onClick={() => confirmSuspendEmployee(item)}>
                                  <TooltipComponent
                                    tag="a"
                                    containerClassName="btn btn-trigger btn-icon"
                                    id={"suspend" + item.id}
                                    icon="user-cross-fill"
                                    direction="top"
                                    text="Suspend"
                                  />
                                </li>
                              </React.Fragment>
                            )}
                            <li className="nk-tb-action-hidden" onClick={() => confirmDeleteEmployee(item)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"delete" + item.id}
                                icon="delete"
                                direction="top"
                                text="Delete"
                              />
                            </li>
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li onClick={() => onEditClick(item._id)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#edit"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="edit"></Icon>
                                        <span>Edit</span>
                                      </DropdownItem>
                                    </li>
                                    {item.status !== "Suspend" && (
                                      <React.Fragment>
                                        <li className="divider"></li>
                                        <li onClick={() => confirmSuspendEmployee(item)}>
                                          <DropdownItem
                                            tag="a"
                                            href="#suspend"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                            }}
                                          >
                                            <Icon name="na"></Icon>
                                            <span>Suspend User</span>
                                          </DropdownItem>
                                        </li>
                                      </React.Fragment>
                                    )}
                                    <li className="divider"></li>
                                    <li onClick={() => confirmDeleteEmployee(item)}>
                                      <DropdownItem
                                        tag="a"
                                        href="#delete"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="delete"></Icon>
                                        <span>Delete</span>
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={employeeList.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Quote</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        defaultValue={formData.name}
                        placeholder="Enter name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Email </label>
                      <input
                        className="form-control"
                        type="text"
                        name="email"
                        defaultValue={formData.email}
                        placeholder="Enter email"
                        ref={register({
                          required: "This field is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Password</label>
                      <input
                        className="form-control"
                        type="password"
                        name="password"
                        defaultValue={formData.password}
                        placeholder="Password"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.password && <span className="invalid">{errors.password.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Phone</label>
                      <input
                        className="form-control"
                        type="number"
                        name="phone"
                        defaultValue={formData.phone}
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Age</label>
                      <input
                        className="form-control"
                        type="number"
                        name="age"
                        defaultValue={formData.age}
                        placeholder="age"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Treatment</label>
                      <input
                        className="form-control"
                        type="text"
                        name="treatment"
                        defaultValue={formData.treatment}
                        placeholder="treatment"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Origin Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="country_provide"
                        defaultValue={formData.origincountry}
                        placeholder="Origin Country"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Language</label>
                      <input
                        className="form-control"
                        type="text"
                        name="language"
                        defaultValue={formData.language}
                        placeholder="Language"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="country_destination"
                        defaultValue={formData.destinationCountry}
                        placeholder="Destination Country"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={filterStatus}
                        name="status"
                        defaultValue={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Add Quote
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Update Quote</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <input type="hidden" value={formData._id} name="_id" />
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Treatment Info</label>
                      <input
                        className="form-control"
                        type="text"
                        name="treatment_info"
                        defaultValue={formData.treatment_info}
                        placeholder="Treatment Info"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Souce Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="souce_country"
                        defaultValue={formData.source_country}
                        placeholder="Source Country"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="destination_country"
                        defaultValue={formData.destination_country}
                        placeholder="Destination Country"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.password && <span className="invalid">{errors.password.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Remarks</label>
                      <input
                        className="form-control"
                        type="text"
                        name="remarks"
                        defaultValue={formData.remarks}
                        placeholder="Remark"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.password && <span className="invalid">{errors.password.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <input
                        className="form-control"
                        type="text"
                        name="status"
                        defaultValue={formData.status}
                        placeholder="Status"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.password && <span className="invalid">{errors.password.message}</span>}
                    </FormGroup>
                  </Col>
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Treatment</label>
                      <input
                        className="form-control"
                        type="text"
                        name="treatment"
                        defaultValue={formData.treatment}
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col> */}
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Origin Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="country_provide"
                        defaultValue={formData.country_provide}
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col> */}
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Language</label>
                      <input
                        className="form-control"
                        type="text"
                        name="language"
                        defaultValue={formData.language}
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col> */}
                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Destination Country</label>
                      <input
                        className="form-control"
                        type="text"
                        name="country_destination"
                        defaultValue={formData.country_destination}
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                    </FormGroup>
                  </Col> */}

                  {/* <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <div className="form-control-wrap">
                        <RSelect
                          options={filterStatus}
                          defaultValue={{
                            value: formData.status,
                            label: formData.status,
                          }}
                          onChange={(e) => setFormData({ ...formData, status: e.value })}
                        />
                      </div>
                    </FormGroup>
                  </Col> */}
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Update Quote
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ConfirmModal
          isOpen={showConfirmModal.isOpen}
          onClose={() => setShowConfirmModal({ isOpen: false, type: null, employee: null, onConfirm: null })}
          onConfirm={showConfirmModal.onConfirm || (() => {})}
          title={showConfirmModal.type === "suspendEmployee" ? "Suspend employee?" : "Delete employee?"}
          message={
            showConfirmModal.type === "suspendEmployee"
              ? (showConfirmModal.employee
                ? `Are you sure you want to suspend "${showConfirmModal.employee.employee_name || "this employee"}"?`
                : "Are you sure you want to suspend this employee?")
              : (showConfirmModal.employee
                ? `Are you sure you want to delete "${showConfirmModal.employee.employee_name || "this employee"}" (${showConfirmModal.employee.employee_email || "N/A"})?\n\nThis action cannot be undone.`
                : "Are you sure you want to delete this employee?")
          }
          confirmText={showConfirmModal.type === "suspendEmployee" ? "Suspend" : "Delete"}
          cancelText="Cancel"
          type={showConfirmModal.type === "suspendEmployee" ? "warning" : "danger"}
          loading={loading}
        />
      </Content>
    </React.Fragment>
  );
};
export default Employees;
